import { useMutation, useQueryClient } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { TipoEvento, CanalEvento, Evento } from '../types';

interface EventoCreateInput {
  empresa_id: string;
  payload: {
    tipo: TipoEvento;
    canal: CanalEvento;
    payload?: Record<string, unknown>;
    data_evento?: string;
    autor?: string;
    contato_id?: string;
    oportunidade_id?: string;
    tarefa_id?: string;
  };
}

export function useEventoCreate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: EventoCreateInput) => {
      return n8nFetch<Evento>('/evento-create', {
        method: 'POST',
        body: JSON.stringify(input),
      });
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['eventos', vars.empresa_id] });
    },
  });
}
